export const adn_env: { [s: string]: (string); } = {
  ADN_ENV_KEY: "dev"
}